module.exports = __webpack_public_path__ + "static/featured-cause-68d68a191baa81aefede54b3b63dcaf0.jpg";